export var dates_abbreviatedWeekdays_friday = {
    key: 'global::dates_abbreviatedWeekdays_friday',
    fallback: "Fri"
};
export var dates_abbreviatedWeekdays_monday = {
    key: 'global::dates_abbreviatedWeekdays_monday',
    fallback: "Mon"
};
export var dates_abbreviatedWeekdays_saturday = {
    key: 'global::dates_abbreviatedWeekdays_saturday',
    fallback: "Sat"
};
export var dates_abbreviatedWeekdays_sunday = {
    key: 'global::dates_abbreviatedWeekdays_sunday',
    fallback: "Sun"
};
export var dates_abbreviatedWeekdays_thursday = {
    key: 'global::dates_abbreviatedWeekdays_thursday',
    fallback: "Thu"
};
export var dates_abbreviatedWeekdays_tuesday = {
    key: 'global::dates_abbreviatedWeekdays_tuesday',
    fallback: "Tue"
};
export var dates_abbreviatedWeekdays_wednesday = {
    key: 'global::dates_abbreviatedWeekdays_wednesday',
    fallback: "Wed"
};
export var dates_longFormat_extended = {
    key: 'global::dates_longFormat_extended',
    fallback: "{{ monthName }} {{ day }}, {{ year }}, {{ time }}"
};
export var dates_longFormat_shortened = {
    key: 'global::dates_longFormat_shortened',
    fallback: "{{ shortMonthName }} {{ day }}, {{ year }}"
};
export var dates_months_april = {
    key: 'global::dates_months_april',
    fallback: "April"
};
export var dates_months_august = {
    key: 'global::dates_months_august',
    fallback: "August"
};
export var dates_months_december = {
    key: 'global::dates_months_december',
    fallback: "December"
};
export var dates_months_february = {
    key: 'global::dates_months_february',
    fallback: "February"
};
export var dates_months_january = {
    key: 'global::dates_months_january',
    fallback: "January"
};
export var dates_months_july = {
    key: 'global::dates_months_july',
    fallback: "July"
};
export var dates_months_june = {
    key: 'global::dates_months_june',
    fallback: "June"
};
export var dates_months_march = {
    key: 'global::dates_months_march',
    fallback: "March"
};
export var dates_months_may = {
    key: 'global::dates_months_may',
    fallback: "May"
};
export var dates_months_november = {
    key: 'global::dates_months_november',
    fallback: "November"
};
export var dates_months_october = {
    key: 'global::dates_months_october',
    fallback: "October"
};
export var dates_months_september = {
    key: 'global::dates_months_september',
    fallback: "September"
};
export var dates_shortMonths_april = {
    key: 'global::dates_shortMonths_april',
    fallback: "Apr"
};
export var dates_shortMonths_august = {
    key: 'global::dates_shortMonths_august',
    fallback: "Aug"
};
export var dates_shortMonths_december = {
    key: 'global::dates_shortMonths_december',
    fallback: "Dec"
};
export var dates_shortMonths_february = {
    key: 'global::dates_shortMonths_february',
    fallback: "Feb"
};
export var dates_shortMonths_january = {
    key: 'global::dates_shortMonths_january',
    fallback: "Jan"
};
export var dates_shortMonths_july = {
    key: 'global::dates_shortMonths_july',
    fallback: "Jul"
};
export var dates_shortMonths_june = {
    key: 'global::dates_shortMonths_june',
    fallback: "Jun"
};
export var dates_shortMonths_march = {
    key: 'global::dates_shortMonths_march',
    fallback: "Mar"
};
export var dates_shortMonths_may = {
    key: 'global::dates_shortMonths_may',
    fallback: "May"
};
export var dates_shortMonths_november = {
    key: 'global::dates_shortMonths_november',
    fallback: "Nov"
};
export var dates_shortMonths_october = {
    key: 'global::dates_shortMonths_october',
    fallback: "Oct"
};
export var dates_shortMonths_september = {
    key: 'global::dates_shortMonths_september',
    fallback: "Sep"
};
export var dates_weekdays_friday = {
    key: 'global::dates_weekdays_friday',
    fallback: "Friday"
};
export var dates_weekdays_monday = {
    key: 'global::dates_weekdays_monday',
    fallback: "Monday"
};
export var dates_weekdays_saturday = {
    key: 'global::dates_weekdays_saturday',
    fallback: "Saturday"
};
export var dates_weekdays_sunday = {
    key: 'global::dates_weekdays_sunday',
    fallback: "Sunday"
};
export var dates_weekdays_thursday = {
    key: 'global::dates_weekdays_thursday',
    fallback: "Thursday"
};
export var dates_weekdays_tuesday = {
    key: 'global::dates_weekdays_tuesday',
    fallback: "Tuesday"
};
export var dates_weekdays_wednesday = {
    key: 'global::dates_weekdays_wednesday',
    fallback: "Wednesday"
};
export var documents_btnTooltip_downloadAs = {
    key: 'global::documents_btnTooltip_downloadAs',
    fallback: "Download as {{ extension }}"
};
export var filterPanel_lbls_date = {
    key: 'global::filterPanel_lbls_date',
    fallback: "Date"
};
export var filterPanel_lbls_textSearch = {
    key: 'global::filterPanel_lbls_textSearch',
    fallback: "Text Search"
};
export var graph_tooltipLabel_amount = {
    key: 'global::graph_tooltipLabel_amount',
    fallback: "Amount"
};
export var graph_tooltipLabel_count = {
    key: 'global::graph_tooltipLabel_count',
    fallback: "Count"
};
export var graph_tooltipLabel_currency = {
    key: 'global::graph_tooltipLabel_currency',
    fallback: "Currency"
};
export var graph_tooltipLabel_paymentMethod = {
    key: 'global::graph_tooltipLabel_paymentMethod',
    fallback: "Payment Method"
};
export var graph_tooltipLabel_provider = {
    key: 'global::graph_tooltipLabel_provider',
    fallback: "Provider"
};
export var graph_tooltipLabel_rate = {
    key: 'global::graph_tooltipLabel_rate',
    fallback: "Rate"
};
export var graph_tooltipLabel_status = {
    key: 'global::graph_tooltipLabel_status',
    fallback: "Status"
};
export var graph_tooltipLabel_total = {
    key: 'global::graph_tooltipLabel_total',
    fallback: "Total"
};
export var sharedText_addressProperties_addressLine = {
    key: 'global::sharedText_addressProperties_addressLine',
    fallback: "Address Line {{ addressNumber }}"
};
export var sharedText_addressProperties_city = {
    key: 'global::sharedText_addressProperties_city',
    fallback: "City"
};
export var sharedText_addressProperties_country = {
    key: 'global::sharedText_addressProperties_country',
    fallback: "Country"
};
export var sharedText_addressProperties_state = {
    key: 'global::sharedText_addressProperties_state',
    fallback: "State"
};
export var sharedText_addressProperties_zipCode = {
    key: 'global::sharedText_addressProperties_zipCode',
    fallback: "Zip Code"
};
export var sharedText_btn_clearFilters = {
    key: 'global::sharedText_btn_clearFilters',
    fallback: "Clear Filters"
};
export var sharedText_businessUnitProperties_publicKey = {
    key: 'global::sharedText_businessUnitProperties_publicKey',
    fallback: "Public Key"
};
export var sharedText_cardProperties_binNumber = {
    key: 'global::sharedText_cardProperties_binNumber',
    fallback: "BIN Number"
};
export var sharedText_cardProperties_cardCountry = {
    key: 'global::sharedText_cardProperties_cardCountry',
    fallback: "Card Country"
};
export var sharedText_cardProperties_cardIssuer = {
    key: 'global::sharedText_cardProperties_cardIssuer',
    fallback: "Card Issuer"
};
export var sharedText_cardProperties_cardLevel = {
    key: 'global::sharedText_cardProperties_cardLevel',
    fallback: "Card Level"
};
export var sharedText_cardProperties_cardType = {
    key: 'global::sharedText_cardProperties_cardType',
    fallback: "Card Type"
};
export var sharedText_cardProperties_cardVendor = {
    key: 'global::sharedText_cardProperties_cardVendor',
    fallback: "Card Brand"
};
export var sharedText_connector_of = {
    key: 'global::sharedText_connector_of',
    fallback: "of"
};
export var sharedText_connectors_and = {
    key: 'global::sharedText_connectors_and',
    fallback: "and"
};
export var sharedText_connectors_or = {
    key: 'global::sharedText_connectors_or',
    fallback: "or"
};
export var sharedText_customerProperties_email = {
    key: 'global::sharedText_customerProperties_email',
    fallback: "Email"
};
export var sharedText_customerProperties_firstName = {
    key: 'global::sharedText_customerProperties_firstName',
    fallback: "First Name"
};
export var sharedText_customerProperties_lastName = {
    key: 'global::sharedText_customerProperties_lastName',
    fallback: "Last Name"
};
export var sharedText_customerProperties_phoneNumber = {
    key: 'global::sharedText_customerProperties_phoneNumber',
    fallback: "Phone Number"
};
export var sharedText_customerProperties_username = {
    key: 'global::sharedText_customerProperties_username',
    fallback: "Username"
};
export var sharedText_environment_live = {
    key: 'global::sharedText_environment_live',
    fallback: "live"
};
export var sharedText_environment_test = {
    key: 'global::sharedText_environment_test',
    fallback: "test"
};
export var sharedText_errors_agreeTermsPolicy = {
    key: 'global::sharedText_errors_agreeTermsPolicy',
    fallback: "Please agree to our Terms of Use and Privacy Policy"
};
export var sharedText_errors_alreadyRegistered = {
    key: 'global::sharedText_errors_alreadyRegistered',
    fallback: "We already have you registered. So just go ahead and login."
};
export var sharedText_errors_companyNameRequired = {
    key: 'global::sharedText_errors_companyNameRequired',
    fallback: "Company name is required"
};
export var sharedText_errors_confirmPassword = {
    key: 'global::sharedText_errors_confirmPassword',
    fallback: "Confirm password is required"
};
export var sharedText_errors_defaultError = {
    key: 'global::sharedText_errors_defaultError',
    fallback: "Oops, something went wrong"
};
export var sharedText_errors_domainNameInvalid = {
    key: 'global::sharedText_errors_domainNameInvalid',
    fallback: "That's not a valid domain"
};
export var sharedText_errors_domainNameRequired = {
    key: 'global::sharedText_errors_domainNameRequired',
    fallback: "Domain name is required"
};
export var sharedText_errors_doubleCheckEmailPassword = {
    key: 'global::sharedText_errors_doubleCheckEmailPassword',
    fallback: "Double check your email and password and try again."
};
export var sharedText_errors_emailRequired = {
    key: 'global::sharedText_errors_emailRequired',
    fallback: "Email is required"
};
export var sharedText_errors_firstNameRequired = {
    key: 'global::sharedText_errors_firstNameRequired',
    fallback: "First name is required"
};
export var sharedText_errors_invalidEmail = {
    key: 'global::sharedText_errors_invalidEmail',
    fallback: "That's not a valid email address"
};
export var sharedText_errors_lastNameRequired = {
    key: 'global::sharedText_errors_lastNameRequired',
    fallback: "Last name is required"
};
export var sharedText_errors_passwordMatch = {
    key: 'global::sharedText_errors_passwordMatch',
    fallback: "Passwords don't match"
};
export var sharedText_errors_passwordRequired = {
    key: 'global::sharedText_errors_passwordRequired',
    fallback: "Password is required"
};
export var sharedText_errors_passwordTooLong = {
    key: 'global::sharedText_errors_passwordTooLong',
    fallback: "Password is too long. Maximum length is {{maximumCharacters}} characters"
};
export var sharedText_errors_passwordTooShort = {
    key: 'global::sharedText_errors_passwordTooShort',
    fallback: "Password is too short. Minimum length is {{minimumCharacters}} characters"
};
export var sharedText_errors_tokenInvalid = {
    key: 'global::sharedText_errors_tokenInvalid',
    fallback: "Token is invalid."
};
export var sharedText_formButtons_add = {
    key: 'global::sharedText_formButtons_add',
    fallback: "Add"
};
export var sharedText_formButtons_apply = {
    key: 'global::sharedText_formButtons_apply',
    fallback: "Apply"
};
export var sharedText_formButtons_approve = {
    key: 'global::sharedText_formButtons_approve',
    fallback: "Approve"
};
export var sharedText_formButtons_cancel = {
    key: 'global::sharedText_formButtons_cancel',
    fallback: "Cancel"
};
export var sharedText_formButtons_confirm = {
    key: 'global::sharedText_formButtons_confirm',
    fallback: "Confirm"
};
export var sharedText_formButtons_create = {
    key: 'global::sharedText_formButtons_create',
    fallback: "Create"
};
export var sharedText_formButtons_Delete = {
    key: 'global::sharedText_formButtons_Delete',
    fallback: "Delete"
};
export var sharedText_formButtons_reject = {
    key: 'global::sharedText_formButtons_reject',
    fallback: "Reject"
};
export var sharedText_formButtons_saveChanges = {
    key: 'global::sharedText_formButtons_saveChanges',
    fallback: "Save Changes"
};
export var sharedText_formButtons_submit = {
    key: 'global::sharedText_formButtons_submit',
    fallback: "Submit"
};
export var sharedText_formButtons_update = {
    key: 'global::sharedText_formButtons_update',
    fallback: "Update"
};
export var sharedText_lbl_created = {
    key: 'global::sharedText_lbl_created',
    fallback: "Created"
};
export var sharedText_lbl_disabled = {
    key: 'global::sharedText_lbl_disabled',
    fallback: "disabled"
};
export var sharedText_lbl_enabled = {
    key: 'global::sharedText_lbl_enabled',
    fallback: "enabled"
};
export var sharedText_lbl_folder = {
    key: 'global::sharedText_lbl_folder',
    fallback: "Folder"
};
export var sharedText_lbl_generalError = {
    key: 'global::sharedText_lbl_generalError',
    fallback: "Error has occurred, Please try again later."
};
export var sharedText_lbl_noData = {
    key: 'global::sharedText_lbl_noData',
    fallback: "There is no data"
};
export var sharedText_lbl_password = {
    key: 'global::sharedText_lbl_password',
    fallback: "Password"
};
export var sharedText_lbl_typePasswordAgain = {
    key: 'global::sharedText_lbl_typePasswordAgain',
    fallback: "Type your password again"
};
export var sharedText_operator_endingWith = {
    key: 'global::sharedText_operator_endingWith',
    fallback: "ending with"
};
export var sharedText_operator_isBetween = {
    key: 'global::sharedText_operator_isBetween',
    fallback: "is between"
};
export var sharedText_operators_between = {
    key: 'global::sharedText_operators_between',
    fallback: "between"
};
export var sharedText_operators_equalTo = {
    key: 'global::sharedText_operators_equalTo',
    fallback: "equal to"
};
export var sharedText_operators_greaterThan = {
    key: 'global::sharedText_operators_greaterThan',
    fallback: "greater than"
};
export var sharedText_operators_is = {
    key: 'global::sharedText_operators_is',
    fallback: "is"
};
export var sharedText_operators_isEqualTo = {
    key: 'global::sharedText_operators_isEqualTo',
    fallback: "is equal to"
};
export var sharedText_operators_isGreaterThan = {
    key: 'global::sharedText_operators_isGreaterThan',
    fallback: "is greater than"
};
export var sharedText_operators_isLessThan = {
    key: 'global::sharedText_operators_isLessThan',
    fallback: "is less than"
};
export var sharedText_operators_isNotIn = {
    key: 'global::sharedText_operators_isNotIn',
    fallback: "is not in"
};
export var sharedText_operators_lessThan = {
    key: 'global::sharedText_operators_lessThan',
    fallback: "less than"
};
export var sharedText_operators_notIn = {
    key: 'global::sharedText_operators_notIn',
    fallback: "not in"
};
export var sharedText_operators_startingWith = {
    key: 'global::sharedText_operators_startingWith',
    fallback: "starting with"
};
export var sharedText_paymentProperties_dateCreated = {
    key: 'global::sharedText_paymentProperties_dateCreated',
    fallback: "Date Created"
};
export var sharedText_paymentProperties_financialOperation = {
    key: 'global::sharedText_paymentProperties_financialOperation',
    fallback: "Financial Operation"
};
export var sharedText_paymentProperties_orderDetails = {
    key: 'global::sharedText_paymentProperties_orderDetails',
    fallback: "Order Details"
};
export var sharedText_paymentProperties_orderID = {
    key: 'global::sharedText_paymentProperties_orderID',
    fallback: "Order ID"
};
export var sharedText_paymentProperties_paymentID = {
    key: 'global::sharedText_paymentProperties_paymentID',
    fallback: "Payment ID"
};
export var sharedText_paymentProperties_paymentMethod = {
    key: 'global::sharedText_paymentProperties_paymentMethod',
    fallback: "Payment Method"
};
export var sharedText_paymentProperties_paymentMethodType = {
    key: 'global::sharedText_paymentProperties_paymentMethodType',
    fallback: "Payment Method Type"
};
export var sharedText_paymentProperties_paymentProvider = {
    key: 'global::sharedText_paymentProperties_paymentProvider',
    fallback: "Payment Provider"
};
export var sharedText_paymentProperties_paymentStatus = {
    key: 'global::sharedText_paymentProperties_paymentStatus',
    fallback: "Payment Status"
};
export var sharedText_paymentProperties_paymentType = {
    key: 'global::sharedText_paymentProperties_paymentType',
    fallback: "Payment Type"
};
export var sharedText_paymentProperties_subventionAmount = {
    key: 'global::sharedText_paymentProperties_subventionAmount',
    fallback: "Subvention Amount"
};
export var sharedText_paymentsosProperties_businessUnit = {
    key: 'global::sharedText_paymentsosProperties_businessUnit',
    fallback: "Business Unit"
};
export var sharedText_paymentsosProperties_businessUnits = {
    key: 'global::sharedText_paymentsosProperties_businessUnits',
    fallback: "Business Units"
};
export var sharedText_paymentsosProperties_customerReference = {
    key: 'global::sharedText_paymentsosProperties_customerReference',
    fallback: "Customer Reference"
};
export var sharedText_placeholder_pleaseEnter = {
    key: 'global::sharedText_placeholder_pleaseEnter',
    fallback: "Please enter"
};
export var sharedText_placeholder_search = {
    key: 'global::sharedText_placeholder_search',
    fallback: "Search"
};
export var sharedText_TermsAndConditions_acceptThe = {
    key: 'global::sharedText_TermsAndConditions_acceptThe',
    fallback: "I accept the "
};
export var sharedText_TermsAndConditions_agreeRead = {
    key: 'global::sharedText_TermsAndConditions_agreeRead',
    fallback: " and agree that I have read the "
};
export var sharedText_TermsAndConditions_privacyPolicy = {
    key: 'global::sharedText_TermsAndConditions_privacyPolicy',
    fallback: "Privacy Policy"
};
export var sharedText_TermsAndConditions_termsOfService = {
    key: 'global::sharedText_TermsAndConditions_termsOfService',
    fallback: "Terms of Service"
};
export var sharedText_timeUnits_daily = {
    key: 'global::sharedText_timeUnits_daily',
    fallback: "daily"
};
export var sharedText_timeUnits_date = {
    key: 'global::sharedText_timeUnits_date',
    fallback: "Date"
};
export var sharedText_timeUnits_day = {
    key: 'global::sharedText_timeUnits_day',
    fallback: "Day"
};
export var sharedText_timeUnits_days = {
    key: 'global::sharedText_timeUnits_days',
    fallback: "Days"
};
export var sharedText_timeUnits_hour = {
    key: 'global::sharedText_timeUnits_hour',
    fallback: "Hour"
};
export var sharedText_timeUnits_month = {
    key: 'global::sharedText_timeUnits_month',
    fallback: "Month"
};
export var sharedText_timeUnits_monthly = {
    key: 'global::sharedText_timeUnits_monthly',
    fallback: "monthly"
};
export var sharedText_timeUnits_timezone = {
    key: 'global::sharedText_timeUnits_timezone',
    fallback: "Timezone"
};
export var sharedText_timeUnits_today = {
    key: 'global::sharedText_timeUnits_today',
    fallback: "Today"
};
export var sharedText_timeUnits_week = {
    key: 'global::sharedText_timeUnits_week',
    fallback: "Week"
};
export var sharedText_timeUnits_weekly = {
    key: 'global::sharedText_timeUnits_weekly',
    fallback: "weekly"
};
export var sharedText_title_advancedSearch = {
    key: 'global::sharedText_title_advancedSearch',
    fallback: "Advanced Search"
};
export var sharedText_titleSuffix_optional = {
    key: 'global::sharedText_titleSuffix_optional',
    fallback: "(Optional)"
};
export var sharedText_transactionProperties_amount = {
    key: 'global::sharedText_transactionProperties_amount',
    fallback: "Amount"
};
export var sharedText_transactionProperties_Currency = {
    key: 'global::sharedText_transactionProperties_Currency',
    fallback: "Currency"
};
export var sharedText_transactionProperties_providerConfigurationName = {
    key: 'global::sharedText_transactionProperties_providerConfigurationName',
    fallback: "Provider Configuration Name"
};
export var sharedText_transactionProperties_Status = {
    key: 'global::sharedText_transactionProperties_Status',
    fallback: "Status"
};
export var sharedText_transactionProperties_transactionStatus = {
    key: 'global::sharedText_transactionProperties_transactionStatus',
    fallback: "Transaction Status"
};
export var sharedText_transactionProperties_transactionType = {
    key: 'global::sharedText_transactionProperties_transactionType',
    fallback: "Transaction Type"
};
export var sharedText_warnMsg_unsupportedScreen = {
    key: 'global::sharedText_warnMsg_unsupportedScreen',
    fallback: "{{ unsupportedLang }} is not yet available for this screen"
};
export var sidePanel_lbl_invalidCurrency = {
    key: 'global::sidePanel_lbl_invalidCurrency',
    fallback: "invalid currency code"
};
export var sidePanel_lbl_invalidRange = {
    key: 'global::sidePanel_lbl_invalidRange',
    fallback: "invalid range"
};
export var sidePanel_lbl_invalidUUID = {
    key: 'global::sidePanel_lbl_invalidUUID',
    fallback: "invalid UUID format"
};
export var sidePanel_lbl_missingRangeValue = {
    key: 'global::sidePanel_lbl_missingRangeValue',
    fallback: "both range values are required"
};
export var sidePanel_lbl_missingRequiredField = {
    key: 'global::sidePanel_lbl_missingRequiredField',
    fallback: "{{ field }} is required"
};
export var tooltip_controllerBtnDocs_content = {
    key: 'global::tooltip_controllerBtnDocs_content',
    fallback: "Need help?"
};
